export default __webpack_public_path__ + "static/media/Rotating Table (1).1c192011.jpg";